<ng-container *ngIf="displayFilters">
  <collapsible-pane [title]="searchFiltersText" [collapsed]="!isFiltersSectionExpanded" (onChange)="toggleFiltersSection($event)">
    <formly [form]="form" [fields]="fields" [model]="model" class="report-filters"></formly>
  </collapsible-pane>
</ng-container>
<button class="btn btn-primary" (click)="startSearch()" [busyButton]="loading" translate>GA.BUTTONS.SEARCH</button>

<ng-container *ngIf="dashboardMetadata?.export?.reports?.length > 0">
  <button class="btn export-button float-end" *ngIf="dashboardMetadata.export.reports.length === 1" (click)="doExport(dashboardMetadata.export.reports[0])" [busyButton]="exporting"><i class="fa fa-share-square-o"></i> <span translate>GA.BUTTONS.EXPORT</span></button>
  <div class="btn-group dropdown float-end" dropdown *ngIf="dashboardMetadata.export.reports.length > 1">
    <button class="btn export-button dropdown-arrow-btn dropdown-toggle" dropdownToggle [busyButton]="exporting"><span translate>GA.BUTTONS.EXPORT</span> <span class="caret"></span></button>
    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
      <li *ngFor="let report of dashboardMetadata.export.reports">
        <a role="menuitem" (click)="doExport(report, $event)"><span>{{'DASHBOARD.OD_ORDER.DROPDOWN_EXPORT.' + report.key | translate}}</span></a>
      </li>
    </ul>
  </div>
</ng-container>